import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ClockIcon, FileTextIcon, ShieldIcon, PenToolIcon, ListIcon, UsersIcon, ArrowRightIcon, DownloadIcon, EyeIcon } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
import DollarSignIcon from '../../components/DollarSignIcon';
const ListingProcess = () => {
  return <div className="max-w-4xl mx-auto" data-id="element-615">
      <div className="mb-6" data-id="element-616">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-617">
          Micro-Sukuk Listing Process
        </h1>
        <p className="text-neutral-400" data-id="element-618">
          Application #MS2023-104 • Amani Cafe • Equipment Purchase
        </p>
      </div>
      {/* Process Pipeline */}
      <section className="mb-8" data-id="element-619">
        <Card data-id="element-620">
          <h3 className="font-bold text-lg mb-6" data-id="element-621">Listing Pipeline</h3>
          <div className="relative mb-8" data-id="element-622">
            {/* Pipeline Progress Bar */}
            <div className="absolute top-4 left-0 right-0 h-1 bg-neutral-200" data-id="element-623">
              <div className="bg-primary h-1" style={{
              width: '80%'
            }} data-id="element-624"></div>
            </div>
            {/* Pipeline Stages */}
            <div className="flex justify-between relative" data-id="element-625">
              {/* Stage 1: MSME Initiation */}
              <div className="flex flex-col items-center w-1/6" data-id="element-626">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-627">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-628" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-629">
                  MSME Initiation
                </div>
                <div className="text-xs text-success text-center" data-id="element-630">
                  Completed
                </div>
              </div>
              {/* Stage 2: Digital Advisor */}
              <div className="flex flex-col items-center w-1/6" data-id="element-631">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-632">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-633" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-634">
                  Digital Advisor
                </div>
                <div className="text-xs text-success text-center" data-id="element-635">
                  Completed
                </div>
              </div>
              {/* Stage 3: Rating Agency */}
              <div className="flex flex-col items-center w-1/6" data-id="element-636">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-637">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-638" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-639">
                  Rating Agency
                </div>
                <div className="text-xs text-success text-center" data-id="element-640">
                  Completed
                </div>
              </div>
              {/* Stage 4: Shariah Review */}
              <div className="flex flex-col items-center w-1/6" data-id="element-641">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-642">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-643" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-644">
                  Shariah Review
                </div>
                <div className="text-xs text-success text-center" data-id="element-645">
                  Completed
                </div>
              </div>
              {/* Stage 5: Contract Signing */}
              <div className="flex flex-col items-center w-1/6" data-id="element-646">
                <div className="w-8 h-8 rounded-full bg-success flex items-center justify-center z-10 mb-2" data-id="element-647">
                  <CheckIcon className="w-4 h-4 text-white" data-id="element-648" />
                </div>
                <div className="text-xs font-medium text-center" data-id="element-649">
                  Contract Signing
                </div>
                <div className="text-xs text-success text-center" data-id="element-650">
                  Completed
                </div>
              </div>
              {/* Stage 6: Marketplace Listing */}
              <div className="flex flex-col items-center w-1/6" data-id="element-651">
                <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center z-10 mb-2" data-id="element-652">
                  <ClockIcon className="w-4 h-4 text-white" data-id="element-653" />
                </div>
                <div className="text-xs font-medium text-center text-primary" data-id="element-654">
                  Marketplace
                </div>
                <div className="text-xs text-primary text-center" data-id="element-655">
                  In Progress
                </div>
              </div>
            </div>
          </div>
          <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4 mb-6" data-id="element-656">
            <div className="flex items-center mb-2" data-id="element-657">
              <ClockIcon className="w-5 h-5 text-primary mr-2" data-id="element-658" />
              <h4 className="font-medium text-primary" data-id="element-659">
                Current Stage: Micro-Sukuk Listing
              </h4>
            </div>
            <p className="text-sm text-neutral-500 mb-3" data-id="element-660">
              Your micro-sukuk application has been approved and is now being
              prepared for listing on the marketplace. This process typically
              takes 24-48 hours. You'll be notified once your listing is live
              and available for investor subscription.
            </p>
            <div className="text-sm font-medium" data-id="element-661">
              Estimated completion:{' '}
              <span className="text-primary" data-id="element-662">June 12, 2025</span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-663">
            <div data-id="element-664">
              <h4 className="font-medium mb-3" data-id="element-665">Micro-Sukuk Details</h4>
              <div className="space-y-3" data-id="element-666">
                <div className="flex justify-between" data-id="element-667">
                  <span className="text-sm text-neutral-400" data-id="element-668">Sukuk ID</span>
                  <span className="text-sm font-medium" data-id="element-669">MS2023-104</span>
                </div>
                <div className="flex justify-between" data-id="element-670">
                  <span className="text-sm text-neutral-400" data-id="element-671">Business</span>
                  <span className="text-sm font-medium" data-id="element-672">Amani Cafe</span>
                </div>
                <div className="flex justify-between" data-id="element-673">
                  <span className="text-sm text-neutral-400" data-id="element-674">Purpose</span>
                  <span className="text-sm font-medium" data-id="element-675">
                    Equipment Purchase
                  </span>
                </div>
                <div className="flex justify-between" data-id="element-676">
                  <span className="text-sm text-neutral-400" data-id="element-677">Amount</span>
                  <span className="text-sm font-medium" data-id="element-678">RM 25,000</span>
                </div>
                <div className="flex justify-between" data-id="element-679">
                  <span className="text-sm text-neutral-400" data-id="element-680">Duration</span>
                  <span className="text-sm font-medium" data-id="element-681">6 months</span>
                </div>
                <div className="flex justify-between" data-id="element-682">
                  <span className="text-sm text-neutral-400" data-id="element-683">Profit Rate</span>
                  <span className="text-sm font-medium" data-id="element-684">18% p.a.</span>
                </div>
              </div>
            </div>
            <div data-id="element-685">
              <h4 className="font-medium mb-3" data-id="element-686">Listing Timeline</h4>
              <div className="space-y-4" data-id="element-687">
                <div className="flex" data-id="element-688">
                  <div className="mr-3 relative" data-id="element-689">
                    <div className="w-6 h-6 rounded-full bg-success flex items-center justify-center" data-id="element-690">
                      <CheckIcon className="w-3 h-3 text-white" data-id="element-691" />
                    </div>
                    <div className="absolute top-6 bottom-0 left-1/2 w-0.5 -ml-px bg-neutral-200" data-id="element-692"></div>
                  </div>
                  <div className="flex-1 pb-4" data-id="element-693">
                    <div className="text-sm font-medium" data-id="element-694">
                      Application Submitted
                    </div>
                    <div className="text-xs text-neutral-400" data-id="element-695">
                      June 8, 2025 • 10:25 AM
                    </div>
                  </div>
                </div>
                <div className="flex" data-id="element-696">
                  <div className="mr-3 relative" data-id="element-697">
                    <div className="w-6 h-6 rounded-full bg-success flex items-center justify-center" data-id="element-698">
                      <CheckIcon className="w-3 h-3 text-white" data-id="element-699" />
                    </div>
                    <div className="absolute top-6 bottom-0 left-1/2 w-0.5 -ml-px bg-neutral-200" data-id="element-700"></div>
                  </div>
                  <div className="flex-1 pb-4" data-id="element-701">
                    <div className="text-sm font-medium" data-id="element-702">
                      Digital Advisor Approval
                    </div>
                    <div className="text-xs text-neutral-400" data-id="element-703">
                      June 9, 2025 • 2:15 PM
                    </div>
                  </div>
                </div>
                <div className="flex" data-id="element-704">
                  <div className="mr-3 relative" data-id="element-705">
                    <div className="w-6 h-6 rounded-full bg-success flex items-center justify-center" data-id="element-706">
                      <CheckIcon className="w-3 h-3 text-white" data-id="element-707" />
                    </div>
                    <div className="absolute top-6 bottom-0 left-1/2 w-0.5 -ml-px bg-neutral-200" data-id="element-708"></div>
                  </div>
                  <div className="flex-1 pb-4" data-id="element-709">
                    <div className="text-sm font-medium" data-id="element-710">Contract Signed</div>
                    <div className="text-xs text-neutral-400" data-id="element-711">
                      June 10, 2025 • 9:30 AM
                    </div>
                  </div>
                </div>
                <div className="flex" data-id="element-712">
                  <div className="mr-3" data-id="element-713">
                    <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center" data-id="element-714">
                      <ClockIcon className="w-3 h-3 text-white" data-id="element-715" />
                    </div>
                  </div>
                  <div className="flex-1" data-id="element-716">
                    <div className="text-sm font-medium text-primary" data-id="element-717">
                      Marketplace Listing
                    </div>
                    <div className="text-xs text-primary" data-id="element-718">In Progress</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Document Preview */}
      <section className="mb-8" data-id="element-719">
        <Card data-id="element-720">
          <h3 className="font-bold text-lg mb-4" data-id="element-721">Documents & Certificates</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-722">
            <div className="border border-neutral-200 rounded-lg p-4" data-id="element-723">
              <div className="flex items-center mb-3" data-id="element-724">
                <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-725">
                  <FileTextIcon className="w-4 h-4 text-secondary" data-id="element-726" />
                </div>
                <h4 className="font-medium" data-id="element-727">Micro-Sukuk Certificate</h4>
              </div>
              <p className="text-xs text-neutral-400 mb-4" data-id="element-728">
                Official certificate of your micro-sukuk issuance
              </p>
              <div className="flex justify-between" data-id="element-729">
                <Button variant="ghost" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-731" />} iconPosition="left" data-id="element-730">
                  Preview
                </Button>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-733" />} iconPosition="left" data-id="element-732">
                  Download
                </Button>
              </div>
            </div>
            <div className="border border-neutral-200 rounded-lg p-4" data-id="element-734">
              <div className="flex items-center mb-3" data-id="element-735">
                <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-736">
                  <ShieldIcon className="w-4 h-4 text-secondary" data-id="element-737" />
                </div>
                <h4 className="font-medium" data-id="element-738">Shariah Compliance</h4>
              </div>
              <p className="text-xs text-neutral-400 mb-4" data-id="element-739">
                Shariah compliance certification
              </p>
              <div className="flex justify-between" data-id="element-740">
                <Button variant="ghost" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-742" />} iconPosition="left" data-id="element-741">
                  Preview
                </Button>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-744" />} iconPosition="left" data-id="element-743">
                  Download
                </Button>
              </div>
            </div>
            <div className="border border-neutral-200 rounded-lg p-4" data-id="element-745">
              <div className="flex items-center mb-3" data-id="element-746">
                <div className="w-8 h-8 rounded-full bg-secondary bg-opacity-10 flex items-center justify-center mr-2" data-id="element-747">
                  <PenToolIcon className="w-4 h-4 text-secondary" data-id="element-748" />
                </div>
                <h4 className="font-medium" data-id="element-749">Signed Contract</h4>
              </div>
              <p className="text-xs text-neutral-400 mb-4" data-id="element-750">
                Fully executed micro-sukuk agreement
              </p>
              <div className="flex justify-between" data-id="element-751">
                <Button variant="ghost" size="sm" icon={<EyeIcon className="w-4 h-4" data-id="element-753" />} iconPosition="left" data-id="element-752">
                  Preview
                </Button>
                <Button variant="outline" size="sm" icon={<DownloadIcon className="w-4 h-4" data-id="element-755" />} iconPosition="left" data-id="element-754">
                  Download
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </section>
      {/* Next Steps */}
      <section className="mb-8" data-id="element-756">
        <Card data-id="element-757">
          <h3 className="font-bold text-lg mb-4" data-id="element-758">Next Steps</h3>
          <div className="space-y-4" data-id="element-759">
            <div className="flex items-start" data-id="element-760">
              <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center mr-3 flex-shrink-0" data-id="element-761">
                <ListIcon className="w-4 h-4 text-white" data-id="element-762" />
              </div>
              <div data-id="element-763">
                <h4 className="font-medium mb-1" data-id="element-764">Marketplace Listing</h4>
                <p className="text-sm text-neutral-400 mb-2" data-id="element-765">
                  Your micro-sukuk will be listed on the investor marketplace
                  within 24-48 hours. You'll receive a notification once it's
                  live.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-766">
              <div className="w-8 h-8 rounded-full bg-neutral-200 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-767">
                <UsersIcon className="w-4 h-4 text-neutral-500" data-id="element-768" />
              </div>
              <div data-id="element-769">
                <h4 className="font-medium mb-1" data-id="element-770">Investor Subscription</h4>
                <p className="text-sm text-neutral-400 mb-2" data-id="element-771">
                  Investors will be able to subscribe to your micro-sukuk.
                  You'll receive updates on the funding progress.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-772">
              <div className="w-8 h-8 rounded-full bg-neutral-200 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-773">
                <DollarSignIcon className="w-4 h-4 text-neutral-500" data-id="element-774" />
              </div>
              <div data-id="element-775">
                <h4 className="font-medium mb-1" data-id="element-776">Fund Disbursement</h4>
                <p className="text-sm text-neutral-400 mb-2" data-id="element-777">
                  Once fully subscribed, funds will be disbursed directly to the
                  vendor for equipment purchase.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-6 flex flex-col sm:flex-row justify-end gap-3" data-id="element-778">
            <Button variant="outline" data-id="element-779">View Application Details</Button>
            <Link to="/demo/investor-view" data-id="element-780">
              <Button variant="primary" icon={<ArrowRightIcon className="w-4 h-4" data-id="element-782" />} iconPosition="right" data-id="element-781">
                Preview Investor View
              </Button>
            </Link>
          </div>
        </Card>
      </section>
    </div>;
};
export default ListingProcess;